import { render, staticRenderFns } from "./mobileContent.vue?vue&type=template&id=130ecfa2&scoped=true&"
import script from "./mobileContent.vue?vue&type=script&lang=js&"
export * from "./mobileContent.vue?vue&type=script&lang=js&"
import style0 from "./mobileContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./mobileContent.vue?vue&type=style&index=1&id=130ecfa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130ecfa2",
  null
  
)

export default component.exports